(() => {
  const unavailable = new Map([
    ['CASE STUDY 2.5', 'CASE STUDY 2.5'],
    ['CASE STUDY 2.5 (COMING SOON)', 'CASE STUDY 2.5'],
    ['CASE STUDY 2', 'CASE STUDY 2'],
    ['CASE STUDY 2 (COMING SOON)', 'CASE STUDY 2'],
    ['CASE STUDY 1', 'CASE STUDY 1'],
    ['CASE STUDY 1 (COMING SOON)', 'CASE STUDY 1']
  ]);
  const normalise = value => value.replace(/\s+/g, ' ').trim().toUpperCase();

  function widestMenuRow(element) {
    let current = element;
    let best = element;
    const viewport = document.documentElement.clientWidth;
    while (current && current !== document.body && current !== document.documentElement) {
      const width = current.getBoundingClientRect().width;
      if (width > best.getBoundingClientRect().width && width <= viewport + 2) best = current;
      if (width >= viewport * 0.88) break;
      current = current.parentElement;
    }
    return best;
  }

  function updateMenus(root = document.body) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node => {
      const replacement = unavailable.get(normalise(node.nodeValue || ''));
      if (!replacement) return;
      const original = node.nodeValue || '';
      const leading = original.match(/^\s*/)?.[0] || '';
      const trailing = original.match(/\s*$/)?.[0] || '';
      node.nodeValue = leading + replacement + trailing;

      const element = node.parentElement;
      if (!element) return;
      const target = element.closest('a, button, [role="link"], [onclick], [data-href], li') || element;
      target.classList.add('aeliza-case-study-coming-soon');
      target.setAttribute('aria-disabled', 'true');
      target.setAttribute('tabindex', '-1');

      const row = widestMenuRow(target);
      if (row && matchMedia('(max-width: 749px)').matches) {
        row.classList.add('aeliza-case-study-row');
      }
    });
  }

  let queued = false;
  function queueUpdate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      updateMenus();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  } else queueUpdate();
  new MutationObserver(queueUpdate).observe(document.documentElement, { childList: true, subtree: true });
  addEventListener('resize', queueUpdate);
  document.addEventListener('click', event => {
    if (event.target.closest('.aeliza-case-study-coming-soon')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();